{
  "api": {
    "locationValidationTitle": "我们无法验证您的位置",
    "thresholdTitle": "未在规定时间内签到",
    "warehouseUnavailableTitle": "仓库暂不可用",
    "warehouseUnavailableMessage": "请联系仓库工作人员进行人工签到",
    "characterLimitTitle": "输入内容超出字符限制",
    "genericTitle": "签到失败，请重试。",
    "recaptchaTitle": "验证失败",
    "recaptchaMessage": "我们无法验证您的请求，请重试或联系仓库工作人员。"
  }
}
